<template>
    <div>
        <el-card class="box-card box-cards" shadow="never">
            <el-row>
                <el-form :inline="true" class="user-search">
                    <el-col :span="24">
                        <el-form-item>
                            <div class="card_top"><span>词书单元列表</span></div>
                        </el-form-item>
                        <el-form-item label="搜索：">
                            <el-input size="small" v-model="formInline.params.keyword" placeholder="输入关键字"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                            <el-button size="small" type="primary" plain @click="handleEdit()">添加
                            </el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
        </el-card>
        <el-card class="box-card box-cards2" shadow="never">
            <!--列表-->
            <el-table border ref="multipleTable" :data="tableData" :header-cell-style="headStyle" tooltip-effect="dark"
                style="width: 100%; " v-loading="loading">
                <el-table-column prop="id" label="单元id" align="center" width="100"></el-table-column>
                <el-table-column prop="title" label="单元名称" align="center" min-width="180"></el-table-column>
                <el-table-column prop="wordType" label="单词类型" align="center" min-width="180">
                    <template slot-scope="scope">
                        <div>{{ getWordType(scope.row.wordType) }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="wordCount" label="单词数量" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.wordCount }} <el-button type="primary" plain icon="el-icon-refresh-right"
                                circle size="mini" title="刷新数量"
                                @click="refreshCount(scope.row.bookId, scope.row.id)"></el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序" align="center"></el-table-column>
                <el-table-column label="操作" width="260">
                    <template slot-scope="scope">
                        <div>
                            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">修改
                            </el-button>
                            <el-button size="mini" type="danger" @click="handleEditdel(scope.row.id)">删除 </el-button>
                            <el-button size="mini" @click="peizhi(scope.row)">查看单词 </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-card>
        <el-drawer :title="title" :visible.sync="editFormVisible" :before-close="handleClose" direction="rtl"
            custom-class="demo-drawer" ref="drawer" size="30%">
            <div class="demo-drawer__content">
                <el-row>
                    <el-form label-width="110px" :model="editForm" :rules="rules" ref="editForm">
                        <el-col :span="22">
                            <div class="grid-content bg-purple">
                                <el-form-item label="单元名称" prop="title">
                                    <el-input v-model="editForm.params.title" placeholder="请输入单元名称"></el-input>
                                </el-form-item>
                                <el-form-item label="单词类型" prop="name">
                                    <el-select v-model="editForm.params.wordType" placeholder="请选择单词类型">
                                        <el-option v-for="item in options" :key="item.id" :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="单词数量" prop="name">
                                    <el-input v-model="editForm.params.wordCount" placeholder="请输入单词数量"></el-input>
                                </el-form-item>
                                <el-form-item label="排序" prop="name">
                                    <el-input v-model="editForm.params.sort" placeholder="排序权重"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>

                    </el-form>
                </el-row>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="handleClose">取消</el-button>
                    <el-button size="small" type="goon" :loading="loading" class="title"
                        @click="submitForm('editForm')">
                        保存</el-button>
                </div>
                <div style="height: 60px; margin-top: 50px"></div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import Pagination from "../../components/Pagination";
import debounce from "../../utils/debounce";
import { bookunitlist, bookunitdelete, bookunitupdate, booksupdateCount, bookstypes } from "../../api/userMG";
export default {
    data() {
        return {
            title: "编辑信息",
            options: [],
            editFormVisible: false,
            //分页
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10,
            },
            tableData: [], //表格数据 
            formInline: {
                data: {},
                params: {
                    pageNum: 1,
                    pageSize: 10,
                    bookId: 0,
                    keyword: ""
                },
            },
            dialogImageUrl: '',
            dialogVisible: false,
            //添加，修改数据
            editForm: {
                data: {},
                params: {
                    "id": 0,
                    "bookId": 0,
                    "title": "",
                    "wordCount": 0,
                    "wordType": "",
                    "sort": 100
                },
            },
            //规则验证
            rules: {},
        };
    },
    components: {
        Pagination
    },
    created() {
        this.formInline.params.bookId = this.$route.query.id;
        this.getWordTypes()
        //数据列表
        this.getlist(this.formInline);
    },
    methods: {
        headStyle() {
            return {
                background: "#A1BBFF",
                color: "#fff",
                letterSpacing: "2px",
                border: " 1px solid #A1BBFF",
                textAlign: "center",
                height: "39px",
            };
        },
        getWordTypes() {
            bookstypes({
                params: { id: this.formInline.params.bookId }
            }).then((res) => {
                if (res.code != 200) {
                    this.$message({
                        type: "info",
                        message: res.message,
                    });
                } else {
                    this.options = res.data
                }
            }).catch(() => { })

        },
        //显示数据
        getlist(parameter) {
            this.loading = true;
            bookunitlist(parameter)
                .then((res) => {
                    this.loading = false;
                    // console.log("userlist", res);
                    if (res.code != 200) {
                        this.$message({
                            type: "info",
                            message: res.message,
                        });
                    } else {
                        this.tableData = res.data.records;
                        // 分页赋值
                        this.pageparm.currentPage = this.formInline.params.pageNum;
                        this.pageparm.pageSize = this.formInline.params.pageSize;
                        this.pageparm.total = res.data.total;
                        // console.log(this.tableData)
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("加载失败，请稍后再试！");
                });
        },
        getWordType(type) {
            for (var i in this.options) {
                if (this.options[i].id == type) {
                    return this.options[i].name
                }
            }
            return ""
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.params.pageNum = parm.currentPage;
            this.formInline.params.pageSize = parm.pageSize;
            this.getlist(this.formInline);
        },
        // 搜索事件
        search() {
            this.formInline.params.pageNum = 1;
            this.getlist(this.formInline); //显示
        },
        refreshCount(bookId, id) {
            console.log(bookId)
            const data = {
                params: {
                    id: bookId,
                    unitId: id
                },
            }
            booksupdateCount(data)
                .then((res) => {
                    this.getlist(this.formInline);
                    this.$message({
                        message: "刷新成功！",
                        type: "success",
                    });
                })
                .catch((err) => {
                });
        },
        //关闭弹框
        handleClose(done) {
            this.$confirm("还有未保存的工作哦确定关闭吗？")
                .then((_) => {
                    this.editFormVisible = false
                    // done();
                })
                .catch((_) => { });
        },
        //添加，修改
        handleEdit(index, row) {
            this.editFormVisible = true;
            if (row != undefined && row != "undefined") {//修改

                this.editForm = {
                    data: {},
                    params: {
                        "id": row.id,
                        "bookId": row.bookId,
                        "title": row.title,
                        "wordCount": row.wordCount,
                        "wordType": row.wordType,
                        "sort": row.sort
                    },
                }

            } else {//添加   
                this.editForm = {
                    data: {},
                    params: {
                        "id": 0,
                        "bookId": this.formInline.params.bookId,
                        "wordCount": 0,
                        "wordType": "",
                        "title": "",
                        "sort": 100
                    },
                }

            }
        },
        //提交添加，修改
        submitForm(info) {

            debounce(() => {

                bookunitupdate(this.editForm)
                    .then(res => {
                        if (res.code == 200) {
                            this.editFormVisible = false;
                            this.getlist(this.formInline);
                            this.$message({
                                message: "保存成功！",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                type: "info",
                                message: res.message,
                            });
                        }
                    })
                    .catch((err) => {
                        this.editFormVisible = false;
                        this.$message.error("保存失败，请稍后再试！");
                    });

            }, 1500);
        },
        handleEditdel(id) {
            let data = {
                "data": {},
                "params": { "id": id },
            }
            this.$confirm("确定要删除吗?", "信息", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    bookunitdelete(data) //删除
                        .then((res) => {
                            console.log("d", res);
                            if (res.code == 200) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                                this.getlist(this.formInline);
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.message,
                                });
                            }
                        })
                        .catch((err) => {
                            this.loading = false;
                            this.$message.error("删除失败，请稍后再试！");
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        peizhi(row) {
            this.$router.push({ path: './words?id=' + row.bookId + '&unitId=' + row.id })
        },

    },
};
</script>
<style>
@import "../../assets/css/index.css";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.divBox {
    /*flex-direction: row;*/
    float: left;
    position: relative;
    margin-right: 10px;
}

.imgSty {
    margin-left: 3px;
}

.delIcon {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 20px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 145px;
    height: 145px;
    line-height: 145px;
    text-align: center;
}

.avatar {
    width: 145px;
    height: 145px;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/book/units.vue